import React from "react";
import './sdcalendar.scss';
import SDBtn from "./sdBtn";
import SDFinance from "./sdFinance";

class SDcalendar extends React.Component {
    constructor(props) {
        super(props);
        let dateArray = this.initCalendar(props.year, props.month)
        let newArray = this.setEvent(dateArray, props.memo);
        this.state = {
            ...props,
            cData: newArray,
            year: props.year ? props.year : new Date().getFullYear(),
            month: props.month ? props.month : new Date().getMonth(),
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.finance !== this.props.finance) { // => 比較更新前後的 state 屬性
            
            this.setState({
                finance: this.props.finance,
            });
        }
    }

    initCalendar = (year, month) => {
        let initDate = new Date();
        let fdate = new Date(initDate.getFullYear(), initDate.getMonth(), 1);
        if (year && month) {
            fdate = new Date(year, month, 1);
        }

        let ldate = new Date(fdate.getFullYear(), fdate.getMonth() + 1, 0);
        let mLength = (ldate - fdate) / (1000 * 60 * 60 * 24);
        let dateArray = [];

        let weekLenght = Math.ceil((fdate.getDay() + 1 + mLength) / 7);
        
        let startDate = new Date(fdate.getFullYear(), fdate.getMonth(), 1 - fdate.getDay());
        for (let w = 0; w < weekLenght; w++) {
            for (let d = 0; d < 7; d++) {
                dateArray.push({
                    year: startDate.getFullYear(),
                    month: startDate.getMonth(),//toLocaleString('en-us', { month: 'short' }),
                    day: startDate.getDate(),
                    date: startDate,
                    memo: [],
                })
                startDate = new Date(startDate.setDate(startDate.getDate() + 1));
            }
        }

        return dateArray;
    }

    setEvent = (d,m) => {
        m.forEach(tm => {
            d.forEach(td => {
                if (tm.startDate <= td.date && tm.endDate >= td.date) {
                    td.memo.push(tm);
                }
            })
        });

        d.filter(td => td.memo && td.memo.length > 0).forEach((td, ix) => {
            let tmpMemo = td.memo.sort((a,b) => a.index - b.index);
            let newMemo = [];
            let allIndex = tmpMemo.map(object => object.index);
            for (let i = 1; i <= Math.max(...allIndex); i++) {
                let nowMemo = tmpMemo.find(tm => tm.index === i);
                if (nowMemo) {
                    newMemo.push(nowMemo);
                }
                else {
                    newMemo.push({index:i});
                }
            }
            
            td.memo = newMemo;
        });

        return d;
    }

    selectedDate = e => {
        if (e.month !== this.state.month) {
            console.log(`${parseInt(e.month)} - ${parseInt(this.state.month)}, ${e}`)
            this.changeMonth(parseInt(e.month) - parseInt(this.state.month), e);
            console.log('b');
            return; 
        }
        console.log('a');
        this.setSelectDate(e);
    }

    setSelectDate = (e, year, month) => {
        console.log(e);
        let date = this.state.cData; 
        if (year && month) {
            date = this.initCalendar(year, month)
        }

        date.forEach(d => {
            d.selected = false;
        });

        let click = date.find(d => d.month === e.month && d.day === e.day);
        click.selected = true;

        this.setState({
            cData : date,
            year : year ? year : this.state.year,
            month : month ? month : this.state.month,
        });

        this.state.selectDay(e);
    }

    changeYear = (i, t) => {
        let year = this.state.year + i;

        if (!t) {
            this.setState({
                cData: this.initCalendar(year, this.state.month),
                year: year,
                month: this.state.month
            })
            return;
        }

        this.setSelectDate(t, year, this.state.month);
    }

    changeMonth = (i, t) => {
        let month = this.state.month + i;

        if (!t) {
            this.setState({
                cData: this.initCalendar(this.state.year, month),
                year: this.state.year,
                month: month
            })
            return;
        }

        this.setSelectDate(t, this.state.year, month);
    }

    render() {
        let date = new Date(this.state.year, this.state.month, 1);
        let month = date.toLocaleString('en-us', { month: 'short' });
        return (
            <div className="mainBody">
                <div className="monthSet">
                    <SDBtn type={'arrow'} direction={'left'} click={() => this.changeYear(-1)}></SDBtn>
                        <div>{date.getFullYear()}</div>
                    <SDBtn type={'arrow'} click={() => this.changeYear(1)}></SDBtn>
                    <SDBtn type={'arrow'} direction={'left'} click={() => this.changeMonth(-1)}></SDBtn>
                        <div>{month}</div>
                    <SDBtn type={'arrow'} click={() => this.changeMonth(1)}></SDBtn>
                </div>
                <div className="calenderBody">
                    {
                        this.state.cData.map((d, index) => {
                            let cn = ['day'];
                            if (d.selected) cn.push('selectedDay');
                            if (d.month !== this.state.month) cn.push('notMonth');
                            switch (index % 7)
                            {
                                case 0: 
                                    cn.push('sunday');
                                    break;
                                case 6: 
                                    cn.push('saturday');
                                    break;
                                default:
                                    break;
                            }
                            let finance = this.state.finance.filter(m => m.year === d.year && m.month === d.month && m.day === d.day);
                            return <div className={cn.join(' ')} key={d.month + '-' + d.day} onClick={() => this.selectedDate(d)}>
                                <div className="dayTop">
                                    <div className={'dayNumber'}>{d.day}</div>
                                    <SDFinance day={d.day} month={d.month} year={d.year} data={finance}></SDFinance>
                                </div>
                                {
                                    d.memo.map(m => {
                                        let cn = ['memo'];
                                        if (m.startDate && m.startDate.getTime() === d.date.getTime()) cn.push('memoStart');
                                        if (m.endDate && m.endDate.getTime() === d.date.getTime()) cn.push('memoEnd');
                                        const mStyle = {
                                            backgroundColor: m.color
                                        }
                                        return <div className={cn.join(' ')} style={mStyle} key={m.title}>{m.title}</div>
                                    })
                                }
                            </div>
                        })
                    }
                </div>
            </div>
        )
    }
}

export default SDcalendar;

const calendarModel = {
    year: 1988,
    month: 8,
    day: 27,
    date: new Date(),
    selected: false,
    memo: [{
        index: 2,
        startYear: 2022,
        startMonth: 8,
        startDay: 5,
        startHour: 10,
        startDate: new Date(2022,8,5),
        endYear: 2022,
        endMonth: 8,
        endDay: 5,
        endHour: 12,
        endDate: new Date(2022,8,5),
        title: "aaa",
        type: "aaa",
        color: "#aaffff",
    }]
}